module.exports = __webpack_public_path__ + "static_pc/img/ba09.22e254ce.png";